import api from "./Api";

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

const Case = process.env.REACT_APP_CASE_URL || "";
if (!Case) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_CASE_URL in your environment variables."
  );
}

const caseAPI = api(Case);

const fetchPreferenceDOSList = async (caseInfoID: any): Promise<any> => {
  try {
    const response = await caseAPI.get(
      `/api/case/record/preference/address?caseInfoId=${caseInfoID}`
    );
    const data = response.data?.result.map((item: any) => ({
      value: item.id,
      label: item.addressInfo,
      addressType: item.addressType,
    }));

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const fetchPRferenceQMEList = async (
  caseInfoID: number,
  clientType: string
): Promise<any> => {
  try {
    const response = await caseAPI.get(
      `/api/case/record/preference/contact?caseInfoId=${caseInfoID}&clientType=${clientType}`
    );
    const data = response.data?.result.map((item: any) => ({
      value: item.stakeholderContactId,
      label: item.contactFullNameDetails,
    }));

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const fetchPreferenceDetails = async (caseID: any): Promise<any> => {
  try {
    const response = await caseAPI.get(
      `/api/case/record/preference/details?caseInfoId=${caseID}`
    );
    // Map the result to transform pickListItemId into value and displayName into label

    return response.data?.result;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

const addPreference = async (
  preferenceData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await caseAPI.post<ApiResponse<any>>(
      "/api/case/record/preference/add",
      preferenceData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

const updatePreference = async (
  preferenceData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await caseAPI.post<ApiResponse<any>>(
      "/api/case/record/preference/update",
      preferenceData
    );
    const { isSuccess, statusCode, message, result } = response.data;
    return { isSuccess, statusCode, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export {
  fetchPreferenceDOSList,
  fetchPRferenceQMEList,
  fetchPreferenceDetails,
  addPreference,
  updatePreference,
};
